import API from 'vue-lsi-util/APIAccesoV2'

const usuariosV3= {
    async getById(id) {
        return new Promise (
            function (resolve, reject) {
                API.acceder({Ruta: `/usuarios/getById/${id}`, Cartel})
                .then(data => {resolve(data)})
                .catch(puteada => { reject(puteada) })
            }
        )            
    },

    async getByUsernameAndPassword(username, password) {
        return new Promise (
            function (resolve, reject) {
                API.acceder({Ruta: `/usuarios/getByUsernameAndPassword/${username}/${password}`})
                .then(data => {resolve(data)})
                .catch(puteada => { reject(puteada) })
            }
        )            
    },


    async getAll() {
        return new Promise (
          function (resolve, reject) {
            API.acceder({Ruta: `/usuarios/getAll`, Cartel: "Obteniendo Usuarios"})
            .then(response => {resolve(response)})
            .catch(puteada => {reject(puteada)})
          }
        )            
      },
    
    
      async saveUsuario(payload) {
        return new Promise (
            function (resolve, reject) {
                API.acceder({
                    Ruta: `/usuarios/newOne`,
                    Metodo: "PUT",
                    Body: payload,
                    Cartel: "Creando Usuario"
                })
                .then(data => {resolve(data)})
                .catch(puteada => { reject(puteada) })
            }
        )            
    },
    
    async editUsuario(id, payload) {
      return new Promise (
          function (resolve, reject) {
              API.acceder({
                  Ruta: `/usuarios/editOneById/${id}`,
                  Metodo: "PATCH",
                  Body: payload,
                  Cartel: "Editando Usuario"
              })
              .then(data => {resolve(data)})
              .catch(puteada => { reject(puteada) })
          }
      )            
    },

}

export default usuariosV3